import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
 ItemsList,
 ItemContainer,
 ItemWrapper,
 ItemName,
} from "./SidebarStyles";
import { dummyData } from "./../index";
const SidebarItems = ({ displaySidebar }) => {
const [activeItem, setActiveItem] = useState(0);
const location = useLocation();
return (
 <ItemsList>
 {dummyData.map((itemData, index) => (
 <ItemContainer
 key={index}
 onClick={() => setActiveItem(itemData.id)}
 className={itemData.id === activeItem ? "active" : ""}
 >
 <Link to={itemData.path}>
 <ItemWrapper>
 {/* {itemData.icon} */}
 <ItemName displaySidebar={displaySidebar}>
 {itemData.name}
 </ItemName>
 </ItemWrapper>
 </Link>
 </ItemContainer>
 ))}
 </ItemsList>
 );
};
export default SidebarItems;